// /trust/provenance — PRD 16 C1, the provenance & audit trail.
//
// A ROOT route beside `/trust`, deliberately not a child of `_shell`. PRD 16
// decision D2 puts Tier C on a surface separate from the analytics dashboard,
// and this is the second page on that surface.
//
// UNLIKE `/trust`, THIS ONE READS TENANT DATA. The ledger at `/trust` renders
// a build-time constant and is shown before purchase without an account; this
// page renders one org's own record, so the gate is real and lives on the
// endpoint (`GET /docs/audit/provenance` resolves the org from the session
// cookie or the license key and 401s otherwise). The screen branches on that
// 401 into a sign-in prompt rather than an empty record — an unauthenticated
// reader must never see a blank page that reads as "nothing to attest to".

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { ProvenanceScreen } from "../screens/trust";

export const trustProvenanceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/trust/provenance",
  component: ProvenanceScreen,
});
